import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import EvomUtils from 'util/EvomUtils';
import { useSetNotificationRead } from 'hooks/api/notifications';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  Link,
  Chip,
} from '@material-ui/core';

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  return date.toLocaleDateString('pt-BR');
};

const UserModalNotificationsDialog = ({ open, onClose, notifications }) => {
  const history = useHistory();
  const { mutate: markAsRead } = useSetNotificationRead();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (open) {
      setCurrentIndex(0);
    }
  }, [open]);

  if (!notifications || !notifications.length) return null;

  const currentNotification = notifications[currentIndex] || {};
  const totalNotifications = notifications.length;
  const isLast = currentIndex === totalNotifications - 1;

  const {
    type,
    version,
    createdAt,
    title,
    content,
    link,
    linkLabel,
  } = currentNotification;

  const renderList = (label, items) => {
    if (!items || !items.length) return null;
    return (
      <Box mt={2}>
        <Typography variant="subtitle2" gutterBottom>
          {label}
        </Typography>
        <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
          {items.map((item, index) => (
            <li key={index}>
              <Typography variant="body2" component="span">
                {item}
              </Typography>
            </li>
          ))}
        </ul>
      </Box>
    );
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle disableTypography>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
          <Box display="flex" alignItems="center" style={{ gap: 8 }}>
            {type && (
              <Chip
                label={EvomUtils.formatBackofficeNotificationType(type)}
                style={EvomUtils.getBackofficeNotificationTypeColor(type, false)}
                size="small"
              />
            )}
            {version && (
              <Chip
                label={version}
                size="small"
                style={{ backgroundColor: '#e0e0e0' }}
              />
            )}
          </Box>
          {createdAt && (
            <Typography variant="caption" color="textSecondary">
              {formatDate(createdAt)}
            </Typography>
          )}
        </Box>
        <Typography variant="h6">{title || 'Notificação'}</Typography>
      </DialogTitle>

      <DialogContent>
        {content && (
          <Typography variant="body1" style={{ whiteSpace: 'pre-line' }} gutterBottom>
            {content}
          </Typography>
        )}

        {link && (
          <Box mt={2}>
            <Link href={link} target="_blank" rel="noopener noreferrer" variant="body2">
              {linkLabel || 'Ver todas as novidades'}
            </Link>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Box flex={1} display="flex" alignItems="center" pl={2}>
          <Typography variant="caption" color="textSecondary">
            {currentIndex + 1} de {totalNotifications}
          </Typography>
        </Box>

        {!link && totalNotifications > 1 && (
          <Button
            color="primary"
            onClick={() => {
              history.push('/notifications');
              onClose();
            }}
          >
            Ver todas as novidades
          </Button>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={() => isLast ? onClose() : setCurrentIndex(currentIndex + 1)}
        >
          {isLast ? 'Fechar' : 'Próximo'}
        </Button>

        <Button
          variant="contained"
          onClick={() => {
            markAsRead(currentNotification.id);
            if (isLast) {
              onClose();
            } else {
              setCurrentIndex(currentIndex + 1);
            }
          }}
          style={{ marginLeft: 8 }}
        >
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserModalNotificationsDialog;
